import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { ChartSVG } from '@common_components/svg/chart.svg';

const ChartIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <ChartSVG/>
    </div>
  );
};

export { ChartIcon };
